
<template>
    
        <mars-view class="catalogue"><mars-view v-show="isCatalogueShow" class="catalogue-mask" catchtouchmove="true" @click.native="changeCatalogueShow"></mars-view><mars-view class="catalogues"><mars-view class="catalogue-items" :class="{'show': isCatalogueShow}"><mars-view class="catalogue-items-title">
                目录
            </mars-view><mars-view class="catalogue-containter"><mars-view v-for="(item, i) in contents" :key="i" class="catalogue-item" @click.native="contentsClick(item)"><mars-view class="catalogue-item-title">{{ item.title }}</mars-view><mars-view class="catalogue-item-text c-line-clamp1">{{ item.text }}</mars-view></mars-view></mars-view></mars-view></mars-view></mars-view>
    
</template>

<script>
export default {
  props: {
    isCatalogueShow: {
      type: Boolean,
      default() {
        return false;
      }
    },
    contents: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  components: {},
  methods: {
    // 点击目录进行定位
    contentsClick(item) {
      this.$emit('contentsClick', item);
    },
    // 关闭目录mask
    changeCatalogueShow() {
      this.$emit('changeCatalogueShow');
    }
  }
};
</script>

<style scoped>
.catalogue .catalogue-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: 999;
}
.catalogue .catalogue-items {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 65%;
  right: -65%;
  padding-left: 23px;
  padding-right: 23px;
  background: #fff;
  z-index: 999;
  display: flex;
  flex-direction: column;
  transition: right 0.5s;
  box-sizing: border-box;
}
.catalogue .catalogue-items .catalogue-items-title {
  margin-top: 90px;
  font-size: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid #E0E0E0;
}
.catalogue .catalogue-items .catalogue-containter {
  overflow: auto;
  flex: 1;
  padding-top: 10px;
}
.catalogue .catalogue-items .catalogue-item {
  line-height: 48px;
  font-size: 19px;
  flex: 1;
  display: flex;
}
.catalogue .catalogue-items .catalogue-item .catalogue-item-title {
  width: auto;
}
.catalogue .catalogue-items .catalogue-item .catalogue-item-text {
  flex: 1;
  margin-left: 20px;
}
.catalogue .show {
  right: 0;
}

</style>
